<app-paged-table [isCustomTable]="true" mode="base-2">
  <ng-container pre-table>
    <div>
      <p class="p1">
        {{ 'History:' | trans:'cards/card/tickets-history/history.Label' }}
      </p>
    </div>
  </ng-container>

  <ng-container table>
    <div class="d-flex gap-24 m-t-16 ticket-information-wrapper align-items-start">
      <div class="flex-grow-1 w-0">
        <ng-container
          [ngTemplateOutlet]="ticketInformationTableTemplate"
          [ngTemplateOutletContext]="{ dataContent: data ? (data | arraySlice:0:5) : [] }"
        />
      </div>

      <div
        class="p-l-24 flex-grow-1 w-0"
        [class.left-separator]="(data ? (data | arraySlice:5:10) : []).length > 0"
      >
        <ng-container
          [ngTemplateOutlet]="ticketInformationTableTemplate"
          [ngTemplateOutletContext]="{ dataContent: data ? (data | arraySlice:5:10) : [] }"
        />
      </div>
    </div>
  </ng-container>
</app-paged-table>

<ng-template #ticketInformationTableTemplate let-dataContent="dataContent">
  <table class="base-2 full-width">
    <tbody>
      @for (val of dataContent; track val) {
        <tr>
          <td>
            <table class="full-width">
              <tr>
                <td>
                  <div class="d-flex align-items-center gap-8">
                    <i class="ri-ticket-line c-t-blue-700"></i>
                    <p class="c-t-blue-700">#{{ val.ticketNr }}</p>
                  </div>
                </td>
                <td></td>
                <td class="text-right">
                  {{ val.transactionDate | localeDatetimeFormat }}
                </td>
              </tr>
              <tr>
                <td class="p-y-4">
                  {{ val.filmTitle }}
                </td>
                <td class="p-y-4"></td>
                <td class="text-right p-y-4">
                  {{ val.saal }}
                </td>
              </tr>
              <tr>
                <td>
                  <div class="tag tag--{{ val.statusKey }}">
                    {{ val.statusKey | trans:'cards/card/tickets-history/history/statusKey.' + val.statusKey }}
                  </div>
                </td>
                <td>
                  {{ val.seatArea }} R{{ val.seatRow }}/P{{ val.seatNumber }}
                </td>
                <td class="text-right">
                  {{ val.amount | numberToCurrency }} {{ languageConfig.currency.short }}
                </td>
              </tr>
            </table>
          </td>
        </tr>
      }
    </tbody>
  </table>
</ng-template>
